import { Fade } from "react-awesome-reveal";

export const HeadLine = (props) => {
    return (
        <Fade
            triggerOnce
            className={`headline  pb-6 xs:pb-8 md:pb-10 lg:pb-12 ${props.customClasses}`}
        >
            <span>{props.children}</span>
        </Fade>
    );
};

export const MainContainer = (props) => {
    return (
        <main className="bg-primary-color text-content-color min-w-full min-h-screen">
            {props.children}
        </main>
    );
};

// ---- for primary containers ----
export const PrimaryContainer = (props) => {
    // max padding in x dir is ~ 64px
    // max padding in y dir is ~ 80px
    return (
        <section className="section-size container-padding-x-dir  container-padding-y-dir">
            {props.children}
        </section>
    );
};

// ---- for secondary containers (which have diff bg color) ----
export const SecondaryContainer = (props) => {
    return (
        <section className="bg-secondary-color">
            <PrimaryContainer>{props.children}</PrimaryContainer>
        </section>
    );
};

export const ErrorContainer = (props) => {
    return <div className="content text-center">{props.children}</div>;
};
